{
  "common": {
    "loading": "Loading…",
    "cancel": "Cancel",
    "save": "Save",
    "authenticationErrorPrefix": "Authentication error:",
    "tryAgain": "Try again",
    "redirectingToLogin": "Redirecting to login…",
    "profileLoadError": "Failed to load your profile.",
    "actions": "Actions",
    "selectStationFirst": "Select a station to continue.",
    "unsavedChanges": {
      "title": "Unsaved changes",
      "message": "You have unsaved changes. Are you sure you want to leave?",
      "stay": "Stay",
      "leave": "Leave"
    }
  },
  "assignmentValidation": {
    "outsideWorkingHours": "This assistance needs coverage from {{requestStartTime}} to {{requestEndTime}} (including the station-configured assistance time), but this callsign works {{callsignStartTime}} to {{callsignEndTime}}. Please select another callsign or adjust the shift.",
    "noStaffAssigned": "No staff assigned to the callsign. Please assign a staff to the callsign before allocating the request"
  },
  "dashboard": {
    "pageTitle": "Requests",
    "filterResultsTitle": "Filter Results",
    "station": "Station",
    "searchLabel": "Search requests",
    "searchPlaceholder": "e.g. Jane Smith, Euston, PA-12345678 or headcode 1A",
    "startDate": "Start Date",
    "endDate": "End Date",
    "search": "Search",
    "clear": "Clear",
    "allBookingRequests": "All",
    "arrivals": "Arrivals",
    "departures": "Departures",
    "tabsAriaLabel": "View filter",
    "presets": {
      "label": "Presets",
      "tomorrow": "Tomorrow",
      "sevenDays": "7 days",
      "thirtyDays": "30 days"
    },
    "noBookingsMessage": "There are no bookings that match your request",
    "requestsTableLabel": "Assistance requests",
    "sortAscending": "Activate to sort ascending",
    "sortDescending": "Activate to sort descending",
    "resultsCount": "{{count}} requests found",
    "badges": {
      "unconfirmed": "Unconfirmed"
    },
    "columns": {
      "paRef": "PA Ref",
      "passenger": "Passenger",
      "requestType": "Type",
      "from": "From",
      "to": "To",
      "journeyDate": "Date",
      "time": "Time",
      "platform": "Platform",
      "headcode": "HC",
      "rsid": "RSID",
      "assignTo": "Assignment",
      "requestChecklist": "Checklist",
      "assistanceDetails": "Details",
      "status": "Status"
    },
    "requestChecklist": {
      "start": "Start",
      "startAriaLabel": "Start checklist",
      "completed": "Done"
    },
    "assignment": {
      "assignToTitle": "Assign to",
      "reassignTitle": "Reassign Request",
      "selectCallsignPrompt": "Please select callsign",
      "assignAction": "Assign",
      "reassignAction": "Reassign",
      "validationReminder": {
        "title": "Validation Reminder",
        "body": "This request is part of an unconfirmed booking. Please complete the required validation before assigning.",
        "checkboxLabel": "I have completed the validation reminder.",
        "cancel": "Cancel",
        "continue": "Continue"
      }
    }
  },
  "table": {
    "emptyDefault": "There's no data that matches your request",
    "defaultAriaLabel": "Results",
    "scrollRegionLabel": "{{name}} table"
  },
  "callback": {
    "signingIn": "Signing in..."
  },
  "shiftTimeline": {
    "title": "Timeline",
    "prototype": {
      "callsignStaff": "Callsign / Staff",
      "unassignedCount": "Unassigned · {{count}}",
      "openQueue": "Open queue",
      "closeQueue": "Close queue",
      "zoomControls": "Timeline zoom",
      "zoomIn": "Zoom in",
      "zoomOut": "Zoom out",
      "zoomWindow": "{{count}}h window",
      "queueTitle": "Unassigned requests · {{count}}",
      "searchLabel": "Search unassigned requests",
      "searchPlaceholder": "Passenger, reference, headcode or station",
      "showing": "Showing {{shown}} of {{total}} requests",
      "showMore": "Show {{count}} more",
      "more": "more",
      "noMatches": "No unassigned requests match this search.",
      "allocationUnavailable": "Allocation unavailable — create a callsign first.",
      "noCallsignsTitle": "No callsigns available for this date",
      "noCallsignsDescription": "Create callsigns before requests can be allocated.",
      "manageShifts": "Manage shifts"
    },
    "view": {
      "listHeading": "Timeline list",
      "listDescription": "Requests and breaks grouped by callsign.",
      "resultCount_one": "{{count}} request shown",
      "resultCount_other": "{{count}} requests shown",
      "noLaneItems": "No requests or breaks for this callsign.",
      "type": "Journey type",
      "assistanceTime": "Assistance time",
      "trainTime": "Scheduled train time",
      "status": "Status",
      "conflict": "Scheduling conflict",
      "manageAssignment": "Manage assignment for {{reference}}",
      "editTimes": "Edit times for {{reference}}",
      "editBreak": "Edit break for {{callsign}}",
      "visualRegionLabel": "Visual callsign timeline",
      "collapseLane": "Collapse {{callsign}} lane",
      "expandLane": "Expand {{callsign}} lane",
      "laneAssistanceCount_one": "{{count}} assistance",
      "laneAssistanceCount_other": "{{count}} assistances",
      "expandCrossover_one": "Expand {{callsign}} to review {{count}} assistance in the crossover group",
      "expandCrossover_other": "Expand {{callsign}} to review {{count}} assistances in the crossover group",
      "crossoverCount_one": "{{count}} assistance in the crossover group",
      "crossoverCount_other": "{{count}} assistances in the crossover group",
      "crossoverBadge_one": "{{count}}x",
      "crossoverBadge_other": "{{count}}x",
      "assignedCallsign": "Assigned callsign {{callsign}}",
      "scheduledTrainTime": "Scheduled train time {{time}}",
      "platformValue": "Platform {{platform}}"
    },
    "timingEditor": {
      "title": "Edit times for {{reference}}",
      "start": "Assistance start time",
      "end": "Assistance end time",
      "invalid": "End time must be later than start time."
    },
    "autoRefreshOn": "Auto-refresh: ON (10s)",
    "autoRefreshOff": "Auto-refresh: OFF",
    "autoRefreshLabel": "Auto-refresh",
    "resume": "Resume",
    "pause": "Pause",
    "dateLabel": "Date:",
    "searchLabel": "Search requests:",
    "searchPlaceholder": "e.g. Jane Smith, Euston, PA-12345678 or headcode 1A",
    "searchButton": "Search",
    "showAllCallsigns": "Show all callsigns",
    "hideOffshiftCallsigns": "Hide offshift callsigns",
    "jumpToNow": "Now",
    "addBreak": "Add Break",
    "loadingTimeline": "Loading shift timeline from RRMS…",
    "errorLoading": "Failed to load RRMS shift timeline. Check network/API.",
    "requestMoveRejected": "Unable to move request. The change was rejected.",
    "rrmsCallsigns": "RRMS callsigns:",
    "unassignedRequests": "Unassigned requests:",
    "callsignBreaks": "Callsign breaks:",
    "addBreakModal": {
      "title": "Add Break",
      "editTitle": "Edit Break",
      "startTime": "Start Time",
      "endTime": "End Time",
      "hours": "Hrs",
      "minutes": "Mins",
      "selectCallsign": "Select Callsign",
      "selectCallsignPlaceholder": "Select callsign...",
      "reason": "Reason:",
      "reasonPlaceholder": "Optional reason for this break",
      "confirm": "Confirm",
      "save": "Save",
      "delete": "Delete break",
      "confirming": "Confirming…",
      "createSuccess": "Break added successfully",
      "updateSuccess": "Break updated successfully",
      "deleteSuccess": "Break deleted successfully",
      "saveError": "Unable to save break. Please try again.",
      "deleteError": "Unable to delete break. Please try again.",
      "missingScheduleSetup": "This station needs a callsign schedule before breaks can be managed.",
      "missingScheduleSetupToast": "Add a callsign schedule before managing breaks.",
      "openScheduleSetup": "Open schedule setup",
      "timeRangeError": "End time must be after start time.",
      "close": "Close"
    },
    "breakTooltip": {
      "title": "Break",
      "timeRange": "{{start}} – {{end}}",
      "reason": "Reason"
    },
    "legend": {
      "conflictingRequests": "Conflicting Requests",
      "caution": "Caution",
      "noConflict": "No Conflict",
      "unassigned": "Unassigned",
      "requiresAttention": "Requires Attention",
      "break": "Callsign Break"
    },
    "alarm": {
      "title": "Unassigned assistance due",
      "category": {
        "DEP": "Departure",
        "ARR": "Arrival"
      }
    }
  },
  "timeline": {
    "title": "Timeline",
    "scrubberHelp": "adjust visible window",
    "visibleWindow": "Visible time window",
    "windowStart": "Visible window start",
    "windowEnd": "Visible window end",
    "tooltip": {
      "scheduled": "Scheduled",
      "timeRange": "Assistance Time",
      "duration": "Duration",
      "platform": "Platform",
      "headcode": "HC",
      "realtimeTime": "Realtime"
    },
    "unknownPassenger": "Unknown passenger",
    "legend": {
      "departure": "Departure",
      "arrival": "Arrival",
      "cautions_one": "{{count}} caution",
      "cautions_other": "{{count}} cautions",
      "conflicts_one": "{{count}} conflict",
      "conflicts_other": "{{count}} conflicts"
    }
  },
  "linkedJobs": {
    "title": "Linked journey",
    "indicatorAriaLabel": "Linked journey: view related requests",
    "summary_one": "{{count}} request in this journey",
    "summary_other": "{{count}} requests in this journey",
    "routeUnavailable": "Route unavailable"
  },
  "journeyIndicators": {
    "lateShort": "Late",
    "lateAria": "Late journey",
    "platformChangedShort": "Plat chg",
    "platformChangedTable": "Changed",
    "platformChangedAria": "Platform changed"
  },
  "cardCollapse": {
    "open": "Open",
    "close": "Close"
  },
  "requestModal": {
    "title": "Manage Request",
    "requestId": "Request ID",
    "type": "Type",
    "label": "Label",
    "status": "Status",
    "startTime": "Start Time",
    "endTime": "End Time",
    "customerName": "Customer Name",
    "additionalInfo": "Additional Info",
    "currentCallsign": "Current Callsign",
    "unassigned": "Unassigned",
    "saveChanges": "Save Changes",
    "cancel": "Cancel",
    "actions": "Actions",
    "editRequest": "Edit Request",
    "selectCallsignPlaceholder": "Select callsign...",
    "reassign": "Reassign",
    "unassign": "Unassign",
    "statusOptions": {
      "noConflict": "No Conflict",
      "caution": "Caution",
      "conflicting": "Conflicting",
      "unassigned": "Unassigned"
    }
  },
  "assistanceDetails": {
    "title": "View Assistance Details",
    "journeyInformation": "Journey Information",
    "paRef": "PA Ref",
    "passengerName": "Passenger Name",
    "headcode": "Headcode",
    "toc": "TOC",
    "departure": "Departure",
    "arrival": "Arrival",
    "stations": "Leg details (stations)",
    "coach": "Coach",
    "platform": "Platform",
    "callsign": "Callsign",
    "assistanceTypes": "Assistance type(s)",
    "unassigned": "Unassigned",
    "notAvailable": "Not available",
    "actions": {
      "assign": "Assign",
      "addNote": "Add note",
      "note": "Note",
      "completeChecklist": "Complete checklist",
      "checklistCompleted": "Checklist completed",
      "emailManager": "Email"
    }
  },
  "assistanceNotes": {
    "title": "Add note",
    "staff": "Staff",
    "username": "Username",
    "addNoteLabel": "Add note",
    "notePlaceholder": "Add details about this assistance…",
    "bookingLog": "Booking log",
    "bookingLogTableCaption": "Booking log notes",
    "loadingBookingLog": "Loading booking log…",
    "bookingLogError": "Unable to load booking log. Please try again.",
    "noBookingLogNotes": "No booking log notes yet.",
    "createdBy": "Created by",
    "createdAt": "Created at",
    "noteText": "Text",
    "unknownUser": "Unknown user",
    "saveSuccess": "Note added successfully",
    "saveError": "Unable to add note. Please try again.",
    "add": "Add",
    "cancel": "Cancel"
  },
  "checklistModal": {
    "depTitle": "DEP Request Checklist",
    "arrTitle": "ARR Request Checklist",
    "loading": "Loading checklist",
    "loadError": "Unable to load checklist details. Please try again.",
    "saveSuccess": "Checklist saved successfully",
    "saveError": "Error saving checklist",
    "noQuestions": "No checklist questions available.",
    "arrivalSectionTitle": "Arrival times",
    "questionsSectionTitle": "Checklist questions",
    "selectPlaceholder": "Select an option",
    "textareaPlaceholder": "Enter details...",
    "questionsById": {},
    "optionsByValue": {
      "yes": "Yes",
      "no": "No",
      "cancelled": "Cancelled",
      "atl": "ATL",
      "fcl": "FCL",
      "noShow": "No Show"
    },
    "confirm": "Confirm",
    "cancel": "Cancel"
  },
  "emailManager": {
    "title": "Email Manager",
    "toLabel": "To",
    "toPlaceholder": "Add email address(es), separated by commas",
    "toHint": "Press Enter, Tab, comma, or semicolon to add each address",
    "suggestions": "Suggestions",
    "removeRecipient": "Remove recipient",
    "reasonLabel": "Please select email reason",
    "reasonSelectPlaceholder": "Select reason",
    "reasonInputLabel": "Reason",
    "reasonInputPlaceholder": "Enter email reason",
    "otherReasonOption": "Other",
    "clearReason": "Clear reason",
    "messageLabel": "Message",
    "messagePlaceholder": "Enter your message",
    "previousEmails": "Previous emails",
    "loading": "Loading email history...",
    "loadError": "Unable to load email history. Please try again.",
    "noHistory": "No previous emails yet.",
    "saveSuccess": "Email sent successfully",
    "saveError": "Failed to send email. Please try again.",
    "cancel": "Cancel",
    "send": "Send Email",
    "validation": {
      "summary": "Please fix the following fields:",
      "toRequired": "Please add at least one recipient email address.",
      "toInvalid": "One or more recipient email addresses are invalid.",
      "reasonRequired": "Please select or enter a reason.",
      "messageRequired": "Please enter a message."
    },
    "history": {
      "to": "To",
      "meta": "Date and reason",
      "by": "Sent by"
    }
  },
  "requestAssign": {
    "title": "Assign Request",
    "detailsTitle": "Request Details",
    "prompt": "Please select callsign:",
    "selectCallsign": "Callsign",
    "selectCallsignPlaceholder": "Select callsign...",
    "callsignsGroup": "Callsigns",
    "staffGroup": "Staff",
    "noOptions": "No assignment targets found.",
    "clearSelection": "Clear selection",
    "cancel": "Cancel",
    "assign": "Assign",
    "reassign": "Reassign",
    "unassign": "Unassign",
    "assignedTo": "Assigned to {{name}}",
    "unassigned": "Unassigned",
    "confirmUnassignTitle": "Confirm unassign",
    "confirmUnassignMessage": "Are you sure you want to unassign this request from its current callsign?",
    "confirmUnassignAction": "Yes, unassign",
    "assignError": "Unable to assign request. The change was rejected.",
    "unassignError": "Unable to unassign request. The change was rejected."
  },
  "scheduleConflicts": {
    "timingConflictWith": "Timing conflict with",
    "summary": {
      "ariaLabel": "Scheduling conflicts summary",
      "title": "Scheduling Conflicts",
      "overall": {
        "none": "No conflicts",
        "critical": "Critical conflicts require attention",
        "high": "High priority conflicts",
        "moderate": "Moderate conflicts"
      },
      "severity": {
        "critical": "Critical",
        "high": "High",
        "moderate": "Moderate"
      },
      "viewDetails": "View details ({{count}})"
    },
    "modal": {
      "title": "Schedule Conflicts",
      "openAria": "Open schedule conflicts details",
      "summary": {
        "critical": "Critical",
        "high": "High",
        "moderate": "Moderate"
      },
      "status": {
        "all": "All",
        "unresolved": "Unresolved",
        "resolved": "Resolved"
      },
      "empty": "No conflicts match the current filter.",
      "resolvedBadge": "Resolved"
    }
  },
  "modal": {
    "closeAriaLabel": "Close modal"
  },
  "switch": {
    "toggleOn": "Toggle on",
    "toggleOff": "Toggle off"
  },
  "nav": {
    "appNameShort": "RRMS",
    "primaryAriaLabel": "Primary navigation",
    "menuOpen": "Open menu",
    "menuClose": "Close menu",
    "skipToMain": "Skip to main content",
    "requestFiltersAriaLabel": "Filter requests by journey type",
    "requests": "Requests",
    "timeline": "Timeline",
    "shifts": "Shifts",
    "configurations": "Configuration",
    "stationLabel": "Station",
    "stationSelectorAriaLabel": "Select station",
    "stationChangeLocked": "Save or discard your changes before switching station.",
    "loadingStations": "Loading stations…",
    "noStations": "No assigned stations",
    "logOut": "Log out",
    "logOutWithUser": "Log out ({{user}})"
  },
  "resources": {
    "overnight": "Overnight",
    "continuesFromPreviousDay": "Continues from the previous day",
    "continuesNextDay": "Continues into the next day",
    "tabs": {
      "ariaLabel": "Shifts sections"
    },
    "stationLabel": "Station:",
    "noStationSelected": "Not selected",
    "enterStationCode": "Enter a station code (e.g. EUS) to load the schedule.",
    "dateLabel": "Date:",
    "table": {
      "callsign": "Callsign",
      "shiftStart": "Shift Start",
      "shiftEnd": "Shift End",
      "staff": "Staff",
      "staffPlaceholder": "Search or select staff...",
      "actions": "Actions",
      "delete": "Delete",
      "empty": "No callsigns for this date.",
      "addCallsign": "Add Callsign",
      "clearStaff": "Remove staff {{name}}",
      "staffLoading": "Loading…",
      "staffNoResults": "No staff found.",
      "staffError": "Could not load staff."
    },
    "actions": {
      "saveChanges": "Save Changes",
      "revert": "Revert",
      "calendar": "Calendar",
      "activityLog": "Activity Log",
      "setDefault": "Schedule",
      "override": "Override",
      "download": "Download"
    },
    "download": {
      "success": "Download requested. We will notify you when the file is ready.",
      "ready": "Your work schedule is ready.",
      "action": "Download",
      "realtimeUnavailable": "Unable to subscribe to download notifications. Please try again.",
      "error": "Unable to start schedule download. Please try again."
    },
    "saveChangesModal": {
      "title": "Save Changes?",
      "cancel": "Cancel",
      "confirm": "Save Changes",
      "error": "Unable to save schedule. Please try again."
    },
    "revertModal": {
      "title": "Revert Changes?",
      "body": "You are about to revert changes made to the schedule. This means that any information that has not been saved will be reverted.\n\nAre you sure you want to continue?",
      "cancel": "Cancel",
      "confirm": "Revert"
    },
    "activityLog": {
      "title": "Activity Log",
      "backToResources": "Back to Shifts",
      "stationLabel": "Station:",
      "actions": {
        "create": "{{scheduleType}} created",
        "update": "{{scheduleType}} updated",
        "delete": "{{scheduleType}} deleted"
      },
      "by": "By {{name}}",
      "effectiveFrom": "From {{date}}",
      "changes": "Operation changes",
      "changeCount_one": "{{count}} change",
      "changeCount_other": "{{count}} changes",
      "empty": "No activity log entries found."
    },
    "schedule": {
      "editorTableRegionLabel": "Callsign schedule editor table",
      "editorTableCaption": "Callsign schedule for {{applicability}}",
      "rowFieldAriaLabel": "{{field}} for callsign {{callsign}}",
      "newCallsign": "new callsign",
      "title": "Shifts",
      "editorAriaLabel": "Schedule editor",
      "loading": "Loading callsign schedule…",
      "types": {
        "baseline": "Schedule",
        "override": "Override"
      },
      "applicability": {
        "all_days": "All days",
        "weekdays": "Weekdays",
        "weekends": "Weekends"
      },
      "overrideRequiresBaseline": "Set up a shift schedule before creating overrides for this station.",
      "multiplePeriodsWarning": "This range currently contains multiple schedules. Saving will replace the whole range with the callsigns shown below.",
      "effectiveFromLabel": "Effective from:",
      "overrideStartLabel": "From:",
      "overrideEndLabel": "To:",
      "sort": {
        "sortBy": "Sort by {{column}}"
      },
      "pattern": {
        "title": "Schedule pattern",
        "allDays": "7 days",
        "split": "Split week",
        "weekdays": "Weekdays",
        "weekends": "Weekends",
        "toggleAriaLabel": "Use separate weekday and weekend schedules",
        "tabsAriaLabel": "Operating day schedule"
      },
      "scheduled": {
        "tableRegionLabel": "Scheduled shift changes table",
        "baselineTitle": "Upcoming Schedule Changes",
        "overrideTitle": "Scheduled Overrides",
        "effectiveFrom": "Effective from",
        "from": "From",
        "to": "To",
        "operatingDays": "Operating Days",
        "edit": "Edit",
        "delete": "Delete",
        "loadError": "Unable to load scheduled changes.",
        "loading": "Loading scheduled changes…",
        "jumpBlocked": "Save or revert your changes before choosing another schedule."
      },
      "saveSuccess": "Schedule saved successfully.",
      "overnightHint": "Overnight — ends the next day.",
      "saveConfirmBody": "You are about to set a new callsign schedule from the selected date onwards. Existing overrides will remain unchanged.\n\nAre you sure you want to continue?",
      "overrideSaveConfirmBody": "You are about to set an override callsign schedule for the selected date range.\n\nAre you sure you want to continue?",
      "deleteModal": {
        "title": "Delete scheduled shift?",
        "baselineBody": "This future schedule will be deleted and the preceding schedule will continue to apply.",
        "overrideBody": "This override will be deleted and the schedule will apply instead.",
        "cancel": "Cancel",
        "confirm": "Delete",
        "success": "Scheduled shift deleted successfully.",
        "error": "Unable to delete the scheduled shift. Please try again."
      },
      "validation": {
        "stationRequired": "Please select a station before saving.",
        "effectiveFromMin": "Effective date must be today or later.",
        "overrideEndBeforeStart": "The override end date must be on or after its start date.",
        "noRows": "Please add at least one callsign before saving.",
        "callsignRequired": "Every callsign row must include a callsign name before saving.",
        "zeroHourShift": "Shift start and end times must be different."
      }
    },
    "calendar": {
      "title": "Shift calendar",
      "dayAgenda": "Day agenda",
      "today": "Today",
      "previousMonth": "Previous month",
      "nextMonth": "Next month",
      "jumpToDate": "Jump to date",
      "overrideFrom": "Override from",
      "overrideTo": "Override to",
      "createOverride": "Create override",
      "rangeHint": "Choose dates here as a keyboard and single-pointer alternative to dragging across the calendar.",
      "weekdays": "Weekday schedule",
      "weekends": "Weekend schedule",
      "override": "Override",
      "moreCallsigns_one": "+{{count}} more callsign",
      "moreCallsigns_other": "+{{count}} more callsigns",
      "moreCallsignsAria_one": "View {{count}} more callsign for {{date}} in the day agenda",
      "moreCallsignsAria_other": "View {{count}} more callsigns for {{date}} in the day agenda",
      "loading": "Loading shift calendar…",
      "loadError": "Unable to load the shift calendar. Please try again."
    },
    "agenda": {
      "title": "Day agenda",
      "close": "Close day agenda",
      "dragHint": "Drag a shift to move it, resize its handles to change its start or end, or select the staff name to reassign it.",
      "today": "Today",
      "previousDay": "Previous day",
      "nextDay": "Next day",
      "jumpToDate": "Jump to date",
      "overrideActive": "One-off override active",
      "pastReadOnly": "Past schedules are read-only",
      "loading": "Loading day agenda…",
      "loadError": "Unable to load the day agenda. Please try again.",
      "empty": "No callsign shifts are scheduled for this day.",
      "timelineAriaLabel": "Hourly shift agenda",
      "currentTime": "Current time",
      "unassigned": "Unassigned",
      "assignStaff": "Assign staff to {{name}}",
      "editTimes": "Edit shift times for {{name}}",
      "editTimesShort": "Edit times",
      "resizeStart": "Change {{name}} shift start",
      "resizeEnd": "Change {{name}} shift end",
      "shiftAriaLabel": "{{name}} shift, {{start}} to {{end}}",
      "editPrompt": {
        "title": "Apply shift change?",
        "staffLabel": "Staff member",
        "startLabel": "Shift start time",
        "endLabel": "Shift end time",
        "scopeTitle": "How should this change apply?",
        "scopeHint": "Choose whether to change only this day or the recurring schedule from this date onwards.",
        "oneOff": "One-off override",
        "oneOffDescription": "Apply this change to the selected day only.",
        "default": "Update schedule",
        "defaultDescription": "Apply this change to the recurring schedule from this date onwards.",
        "cancel": "Cancel",
        "submit": "Apply change",
        "success": "Shift updated successfully.",
        "error": "Unable to update the shift. Please try again."
      }
    }
  },
  "stationManager": {
    "title": "Configuration",
    "noStationTitle": "No operating stations available",
    "noStationDescription": "No RRMS operating stations were returned for your account.",
    "loadErrorTitle": "Unable to load station settings",
    "loadErrorDescription": "There was a problem fetching station settings or your operating stations.",
    "retry": "Retry",
    "stationLabel": "Station",
    "stationHelp": "Select a station to manage settings.",
    "defaultDurationLabel": "Default assistance request duration",
    "defaultDurationHelp": "Set the default length of assistance requests at this station.",
    "transitionTimeLabel": "Minimal journey transition time",
    "transitionTimeHelp": "Set the minimum time between journeys.",
    "autoUpdateLabel": "Auto-update assistance request time",
    "autoUpdateHelp": "Automatically shift assistance timings when related train times change.",
    "alertSectionTitle": "Alert settings",
    "alertSectionDescription": "Configure time-sensitive unassigned assistance alerts for this station.",
    "alarmEnabledLabel": "Enable unassigned assistance due alarm",
    "alarmEnabledHelp": "Alert staff before unassigned assistance reaches its due time.",
    "alarmTimeLabel": "Alarm lead time",
    "alarmTimeHelp": "Set how long before the due time staff are alerted.",
    "minutes": "minutes",
    "seconds": "seconds",
    "save": "Save Settings",
    "toast": {
      "createSuccess": "Station settings created successfully",
      "updateSuccess": "Station settings updated successfully",
      "saveError": "Unable to save station settings. Please try again."
    },
    "validation": {
      "duration": "Enter a positive whole number that isn't too large.",
      "transition": "Enter a non-negative whole number that isn't too large.",
      "alarm": "Enter a positive whole number that isn't too large."
    }
  },
  "realtimeClassification": {
    "DELAYED": "Delayed",
    "DELAYED_INDETERMINATE": "Delayed",
    "LEG_DELAYED_INDETERMINATE": "Delayed",
    "SERIOUSLY_DISRUPTED": "Disrupted",
    "SERIOUSLY_DISRUPTED_INDETERMINATE": "Disrupted",
    "BROKEN_UNREPAIRABLE": "Disrupted",
    "BROKEN": "Disrupted",
    "MISSED_CONNECTION": "Missed connection",
    "CANCELLED": "Cancelled",
    "ONTIME": "",
    "NORMAL": "",
    "ON_TIME_INDETERMINATE": ""
  },
  "app": {
    "title": "Rail Resource Management System",
    "countIs": "count is {{count}}",
    "editAndSave": "Edit {{file}} and save to test HMR",
    "tailwindWorks": "Tailwind works",
    "clickLogos": "Click on the Vite and React logos to learn more",
    "viteLogoAlt": "Vite logo",
    "reactLogoAlt": "React logo"
  }
}
